<!-- components/ProductRecommendations.vue -->
<template>
  <div class="product-recommendations">
	<h2>Recommended Products</h2>
	<p>Based on your assessment results, these Cambro products can help improve your operation:</p>
	
	<div v-if="loading" class="loading">Loading recommendations...</div>
	<div v-else-if="error" class="error">{{ error }}</div>
	<div v-else-if="recommendations.length === 0" class="no-recommendations">
	  No specific product recommendations available.
	</div>
	
	<div v-else class="recommendations-grid">
	  <div v-for="product in recommendations" :key="product.id" class="product-card">
		<h3>{{ product.name }}</h3>
		<div v-if="product.image_url" class="product-image">
		  <img :src="product.image_url" :alt="product.name" />
		</div>
		<a v-if="product.url" 
		   :href="product.url" 
		   target="_blank" 
		   class="learn-more-btn">
		  Learn More
		</a>
	  </div>
	</div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProductRecommendations',
  props: {
	assessment: {
	  type: Object,
	  required: true
	},
	questions: {
	  type: Array,
	  required: true
	},
	userType: {
	  type: String,
	  required: true
	}
  },
  data() {
	return {
	  recommendations: [],
	  categoryGaps: {},
	  loading: false,
	  error: null
	};
  },
  mounted() {
	this.fetchRecommendations();
  },
  methods: {
	async fetchRecommendations() {
	  this.loading = true;
	  this.error = null;
	  
	  try {
		const response = await axios.post(
		  `/api/recommendations/assessment/${this.assessment.id}`,
		  {
			assessment: this.assessment,
			questions: this.questions,
			userType: this.userType
		  },
		  {
			withCredentials: true,
			// baseURL: process.env.VUE_APP_API_URL || 'https://storesafe.fyi'
		  }
		);
		
		this.recommendations = response.data.recommendations;
		this.categoryGaps = response.data.categoryGaps;
		
		console.log('Recommendations loaded:', this.recommendations.length);
	  } catch (error) {
		console.error('Error fetching recommendations:', error);
		this.error = 'Failed to load product recommendations';
	  } finally {
		this.loading = false;
	  }
	}
  }
};
</script>

<style scoped>
.product-recommendations {
  margin: 40px 0;
  padding: 20px;
  background: white;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.product-recommendations h2 {
  color: #EF3E42;
  text-align: center;
  margin-bottom: 10px;
}

.product-recommendations p {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
}

.recommendations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.product-card {
  border: 2px solid #000;
  border-radius: 8px;
  padding: 20px;
  background: white;
  text-align: center;
}

.product-card h3 {
  color: #EF3E42;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
}

.product-scores {
  margin-bottom: 15px;
}

.score-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.score-label {
  color: #666;
}

.score-value {
  font-weight: bold;
  color: #333;
}

.relevance-score {
  font-size: 12px;
  color: #999;
  margin-bottom: 15px;
  font-style: italic;
}

.learn-more-btn {
  display: inline-block;
  background: #EF3E42;
  color: white;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
}

.learn-more-btn:hover {
  background: #c41c1f;
  color: white;
}

.loading, .error, .no-recommendations {
  text-align: center;
  padding: 20px;
  color: #666;
}

.error {
  color: #e74c3c;
}

@media (max-width: 768px) {
  .recommendations-grid {
	grid-template-columns: 1fr;
  }
  
  .product-card {
	padding: 15px;
  }
}
@media print {
  .product-recommendations {
	margin: 20px 0;
	padding: 15px;
	page-break-inside: avoid;
	break-inside: avoid;
  }
  
  .recommendations-grid {
	display: flex !important;
	flex-wrap: wrap !important;
	justify-content: space-between !important;
	gap: 15px !important;
	max-width: 100% !important;
  }
  
  .product-card {
	width: 200px !important;
	min-width: 200px !important;
	max-width: 200px !important;
	margin: 0 !important;
	padding: 15px !important;
	page-break-inside: avoid !important;
	break-inside: avoid !important;
	box-sizing: border-box !important;
  }
  
  .product-card h3 {
	font-size: 14px !important;
	margin-bottom: 10px !important;
  }
  
  .product-image {
	height: 100px !important;
	margin-bottom: 10px !important;
  }
  
  .learn-more-btn {
	font-size: 10px !important;
	padding: 6px 12px !important;
  }
}

/* Force layout for PDF generation libraries */
.pdf-export-mode .recommendations-grid {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: flex-start !important;
  gap: 15px !important;
}

.pdf-export-mode .product-card {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  flex: none !important;
}
</style>